// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__C3EzN","buttons":"RemoveExpirationActionButtons_buttons__2NGhw"};